module.exports = __webpack_public_path__ + "media/images/badges/green-manufacturing-100-a7dceb56b98c47fbd09ec7d1a140f73d.svg";